import React, { useState, useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { I18N, GlobalContext, I18NContext, I18NConsumer, EBModal } from 'commons';
import * as signUpConstants from 'constants/signUp';
import * as locationSelectors from 'state/selectors/locationSelectors';
import * as locationActions from 'state/actions/locationActions';
import SaveButton from 'commons/SaveButton';
import CancelButton from 'commons/CancelButton';
import { Table, Button } from 'reactstrap';
import ViewOnMap from 'components/modals/view-on-map';
import { goNextPage, isEditPage } from 'utils/ebUtils';
import ReactGA from 'react-ga';
import { orgId, setPageTitle } from 'utils';
import { selectShouldShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import AlertBox from 'components/forms/AlertBox'
import SignUpContent from '../SignUpContent';
import SignUpHeader from '../SignUpHeader';
import AddLocationForm from './AddLocationForm';
import LocationformationCard from '../InformationCard';
import ExpectedLocationList from '../review/expected-location/ExpectedLocationList';

const AddressList = ({
  getLocations,
  addresses,
  deleteLocation,
  isEditMode,
  shouldIncidentSubShow,
  deleteExpLocation,
  expLocExpose,
  expLocEditable,
}) => {
  const i18n = useContext(I18NContext);
  const {
    organization: {
      addressSetting: { mandatory = false, editable: addresseEditable = false },
      orgName, showCustomfield, showAlertSubscription, showGroupSubscription
    },
    account: { id: contactId },
  } = useContext(GlobalContext);
  const whichAddress = useRef();
  const whichLocation = useRef();
  const tipLocationText = 'ssp.addresslist.profile.tip';
  const tipLocationTitle = 'new.registration.signup.create.account.label.locationInformation';
  const disable = mandatory && addresses.length === 1;
  const isEmptyLocation = !addresses.length;
  const isNewEditPage = isEditPage('edit-mylocation');
  const [singleAddress, setSingleAddress] = useState({});
  const [isOpenViewOnMap, setIsOpenViewOnMap] = useState(false);
  const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
  const [isOpenAddLocation, setIsOpenAddLocation] = useState(false);
  const [isOpenEditLocation, setIsOpenEditLocation] = useState(false);
  const [isSavedSucceed, setSavedSucceed] = useState(false)
  const [isExpectedLocation, setIsExpectedLocation] = useState(false);
  const [expLocId, setExpLocId] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [expLocForMapView, setExpLocForMapView] = useState({});

  const LocationHeader = styled.h3`
  font-size: 1.25rem;
  padding: 1rem 0px;
`;
  
  const openAddLocation = () => {
    setIsOpenAddLocation(true);
    setIsOpenEditLocation(false);
    setSavedSucceed(false)
    setIsModalOpen(true)
  };
  const closeLocation = () => {
    whichAddress.current = {};
    setSingleAddress({});
    setIsOpenAddLocation(false);
    setIsOpenEditLocation(false);
    setIsExpectedLocation(false);
    setIsModalOpen(false)
  };
  const edit = (address) => {
    setSingleAddress(address);
    setIsOpenAddLocation(false);
    setIsOpenEditLocation(true);
    setIsModalOpen(true)
  };
  const handleDelete = (locationName) =>
    deleteLocation(
      contactId,
      {
        name: locationName,
        success: () => {
          setSingleAddress({});
          setIsOpenAddLocation(false);
          setIsOpenEditLocation(false);
          setIsModalOpen(false)
        }
      });

  const handleExpLocDelete = (expLocId) => {
        deleteExpLocation(
          contactId,
          {
            expectedLocationId: expLocId,
            success: () => {
              setSingleAddress({});
              setIsOpenAddLocation(false);
              setIsOpenEditLocation(false);
              setIsModalOpen(false)
              setIsExpectedLocation(false)
            }
          });
        }

  useEffect(() => {
    ReactGA.pageview(`/newRegistration/locationPage/${orgId}`);
    getLocations(contactId);
  }, []);


  useEffect(() => {
    setIsOpenDeleteConfirm(false);
    //setIsOpenAddLocation(isEmptyLocation);
  }, [addresses]);

  return (
    <div className="sign-up container ssp-well">
      <I18NConsumer>
        {() => setPageTitle(`${orgName} - ${i18n['ssp.register.location.title']}`)}
      </I18NConsumer>
      {
        !isEditMode && <SignUpHeader currentSection={signUpConstants.SIGN_UP_SECTIONS.locations.id} />
      }
      <I18N
        isInLoggedInEditProfileMode={isEditMode}
        tag={SignUpContent}
        i18n-title={isEditMode ? 'ssp.title.locations' : 'new.registration.signup.create.account.label.locationInformation'}
      >
        <div className="form-group row pt-4 p-2">
          <div className="col-12">
            {!mandatory && <p className="content"><I18N>ssp.location.not.mandatory</I18N></p>}
            <I18N
              tag={LocationformationCard}
              className=""
              i18n-tipTitle={tipLocationTitle}
              i18n-tipText={tipLocationText}
            />
          </div>
          <div className="col-md-8">
          <LocationHeader className="h3-gray">
                <I18N>ssp.title.locations.static</I18N>
            </LocationHeader>
            <AlertBox message="home.alert.box.message.location" isSavedSucceed={isSavedSucceed} />
            {!isEmptyLocation && (
              <I18N
                tag={Table}
                striped
                className=""
                i18n-aria-label="new.registration.signup.create.account.label.locationInformation"
              >
                <thead>
                  <tr>
                    <th className="w-30">
                      <I18N>ssp.address.locationname</I18N>
                    </th>
                    <th className="w-40">
                      <I18N>ssp.address.streetaddress</I18N>
                    </th>
                    <th>
                      <I18N>ssp.address.action</I18N>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {addresses.map((address, index) => {
                    const { locationName, streetAddress, lat, lon } = address;
                    const position = { lat, lng: lon };
                    const addressForViewMap = { position };
                    const viewOnMapDisabled = lat === '' && lon === '';
                    return (
                      <tr key={locationName}>
                        <td>{locationName}</td>
                        <td>{streetAddress}</td>
                        <td>
                          <Button
                            onClick={() => { setSavedSucceed(false); setIsExpectedLocation(false); edit(address) }}
                            color="link"
                            eb-test="ssp_location_link_edit_address"
                          >
                            <I18N>{addresseEditable ? 'ssp.address.grid.edit' : 'ssp.address.grid.view'}</I18N>
                          </Button>
                          {!viewOnMapDisabled &&
                            <Button
                              onClick={() => {
                                setSavedSucceed(false)
                                whichAddress.current = addressForViewMap;
                                setIsOpenViewOnMap(true);
                                setIsExpectedLocation(false);
                              }}
                              color="link"
                              eb-test="ssp_location_link_view_on_map"
                            >
                              <I18N>ssp.address.viewonmap</I18N>
                            </Button>
                          }
                          {
                            addresseEditable &&
                            <Button
                              color="link"
                              className="ml-2 p-0"
                              disabled={disable}
                              aria-label={i18n['location.button.delete.alt.text']}
                              onClick={() => {
                                setSavedSucceed(false)
                                setIsExpectedLocation(false)
                                whichLocation.current = locationName;
                                setIsOpenDeleteConfirm(true);
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faTrashAlt}
                                alt={i18n['location.button.delete.alt.text']}
                                width="0.875em"
                                height="1em"
                              />
                            </Button>
                          }
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </I18N>
            )}
            {addresseEditable && addresses.length < 5 && !isOpenAddLocation && !isOpenEditLocation && (
              <div className="p-2 text-right">
                <button
                  className="btn btn-link"
                  type="button"
                  onClick={() => {setIsExpectedLocation(false); openAddLocation()}}
                  eb-test="ssp_location_link_add_address"
                >
                  <I18N>ssp.location.add.address</I18N>
                </button>
              </div>
            )}
            {(isOpenAddLocation || isOpenEditLocation) && (
              
              <I18N
                tag={AddLocationForm}
                isOpenAddLocation={isOpenAddLocation}
                isOpenEditLocation={isOpenEditLocation}
                openAddLocation={openAddLocation}
                closeLocation={closeLocation}
                address={singleAddress}
                isEmptyLocation={isEmptyLocation}
                userAddressList={addresses}
                isEditMode={isEditMode}
                setSavedSucceed={setSavedSucceed}
                isExpectedLocation={isExpectedLocation}
                expLocEditable={expLocEditable}
                isModalOpen={isModalOpen}
                i18n-formTitle="new.registration.signup.create.account.label.locationInformation"
              />
            )}
            { expLocExpose &&
            <div>
              <LocationHeader className="h3-gray">
                <I18N>ssp.title.locations.expected</I18N>
                </LocationHeader>
                <ExpectedLocationList expLocEditable={expLocEditable} openAddLocation={openAddLocation} setSavedSucceed={setSavedSucceed} edit={edit} setIsExpectedLocation={setIsExpectedLocation} setIsOpenDeleteConfirm={setIsOpenDeleteConfirm} setExpLocId={setExpLocId} setExpLocForMapView={setExpLocForMapView} setIsOpenViewOnMap={setIsOpenViewOnMap} isAction = {true}/>
            </div>
            }
            {!isEditMode && !isNewEditPage && !isOpenAddLocation && !isOpenEditLocation && (
              <div className="offset-md-3 col-md-9 pr-2 pt-4">
                <div className="row">
                  <div className="col-md-4" />
                  <SaveButton
                    onClick={() => {
                      goNextPage(
                        {
                          pageUri: 'edit-mylocation',
                          showAlertSubscription,
                          showGroupSubscription,
                          shouldIncidentSubShow,
                          showCustomfield,
                          contactId
                        }
                      );
                    }}
                    ebTestValue="ssp_location_button_save"
                    type="button"
                  />
                </div>
              </div>
            )}
            {isNewEditPage && !isOpenAddLocation && !isOpenEditLocation &&
                <div className="offset-md-3 col-md-9 pr-0">
                  <div className="row">
                    <CancelButton
                      isShow
                      onClick={() => {
                        goNextPage({ pageUri: 'edit-mylocation', contactId });
                      }}
                      ebTestValue="ssp_location_button_cancel"
                    />
                    <SaveButton
                      onClick={() => {
                        goNextPage({ pageUri: 'edit-mylocation', contactId });
                      }}
                      ebTestValue="ssp_location_button_submit"
                      type="button"
                      hasContinue={false}
                    />
                  </div>
                </div>
            }
            <EBModal
              isOpen={isOpenDeleteConfirm}
              toggleModal={() => setIsOpenDeleteConfirm(false)}
              onConfirm={() => isExpectedLocation? handleExpLocDelete(expLocId) : handleDelete(whichLocation.current)}
              ebTestCancelValue="address-delete-cancel"
              ebTestConfirmValue="address-delete-confirm"
              btnConfirmText="ssp.address.grid.delete"
            >
              <div><I18N>location.modal.delete.confirm.content</I18N></div>
            </EBModal>
            {isOpenViewOnMap && (
              <ViewOnMap
                isOpen={isOpenViewOnMap}
                close={() => {setIsOpenViewOnMap(false); setIsExpectedLocation(false)}}
                ok={() => setIsOpenViewOnMap(false)}
                address={isExpectedLocation? expLocForMapView : whichAddress.current}
              />
            )}
          </div>
        </div>
      </I18N>
    </div>
  );
};

AddressList.propTypes = {
  deleteLocation: PropTypes.func.isRequired,
  getLocations: PropTypes.func.isRequired,
  addresses: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
  shouldIncidentSubShow: PropTypes.bool.isRequired,
  deleteExpLocation: PropTypes.func.isRequired,
};

AddressList.defaultProps = {
  addresses: [],
  isEditMode: false,
  expLocExpose: false,
  expLocEditable: false,
};
const mapStateToProps = state => ({
  addresses: locationSelectors.locationAddresses(state),
  expose: locationSelectors.locationExpose(state),
  setIsAddressVerifyPass: true,
  shouldIncidentSubShow: selectShouldShowIncidentSub(state),
  expLocExpose: locationSelectors.expLocExpose(state),
  expLocEditable: locationSelectors.expLocEditable(state),
});

const mapDispatchToProps = dispatch => ({
  getLocations: (contactId) =>
    dispatch(locationActions.getLocationList.action({ contactId })),
  deleteLocation: (contactId, data, callback) => {
    dispatch(locationActions.deleteLocation.action({ contactId, data, callback }));
  },
  deleteExpLocation: (contactId, data, callback) => {
    dispatch(locationActions.deleteExpLocation.action({ contactId, data, callback }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddressList);
